export class GenPersonCustomerEntity{
    id:number;
    personId:number;
    person:string;
    customerId:number;
    customer:string;

    constructor(){}
}